<template>
  <button
    :class="['mastery-button', { [variant]: variant }]"
    :disabled="disabled"
    @click="$emit('mastery-button-clicked')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
button.mastery-button {
  background-color: #6f0079;
  border-radius: 24px;
  color: white;
  font-weight: $semi-bold;
  letter-spacing: 0.5px;
  min-width: rem-calc(170);
  padding: rem-calc(16) rem-calc(24);

  &:disabled {
    opacity: 0.6;
  }

  &.blue {
    background-color: #001c74;
  }

  &.green {
    background-color: #00b46d;
  }
  &.danger {
    background-color: #dc3416;
  }
}
</style>
